import React, { useState, createContext, useContext } from 'react';
export type Category = {
  id: string;
  name: string;
  active: boolean;
  defaultStationId?: string;
  iconColor?: string;
};
const seedCategories: Category[] = [{
  id: 'cat_savory',
  name: 'Savory Plates',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_eggs',
  name: 'Eggs & Omelets',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_ethiopian',
  name: 'Ethiopian Corner',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_salads',
  name: 'Salads',
  active: true,
  defaultStationId: 'cold'
}, {
  id: 'cat_burgers',
  name: 'Burgers and Sandwiches',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_spaghetti',
  name: 'Spaghetti - Classic Long, Thin Strands',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_others',
  name: 'Others',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_delights',
  name: 'Ethiopian Delights',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_asian',
  name: 'Asian Fusion',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_half',
  name: 'Half & Half',
  active: true,
  defaultStationId: 'food'
}, {
  id: 'cat_drinks',
  name: 'Drinks & Beverages',
  active: true,
  defaultStationId: 'bar'
}, {
  id: 'cat_desserts',
  name: 'Desserts & Pastries',
  active: true,
  defaultStationId: 'dessert'
}];
type Ctx = {
  categories: Category[];
  addCategory: (name: string) => void;
  updateCategory: (id: string, patch: Partial<Category>) => void;
  removeCategory: (id: string) => void;
  reorderCategories: (startIndex: number, endIndex: number) => void;
};
const CategoriesContext = createContext<Ctx | null>(null);
export function CategoriesProvider({
  children
}: {
  children: ReactNode;
}) {
  const [categories, setCategories] = useState<Category[]>(seedCategories);
  const addCategory = (name: string) => {
    const newCat: Category = {
      id: `cat_${Date.now().toString(36)}`,
      name,
      active: true,
      defaultStationId: 'food'
    };
    setCategories(prev => [...prev, newCat]);
  };
  const updateCategory = (id: string, patch: Partial<Category>) => {
    setCategories(prev => prev.map(c => c.id === id ? {
      ...c,
      ...patch
    } : c));
  };
  const removeCategory = (id: string) => {
    setCategories(prev => prev.filter(c => c.id !== id));
  };
  const reorderCategories = (startIndex: number, endIndex: number) => {
    setCategories(prev => {
      const result = Array.from(prev);
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
      return result;
    });
  };
  return <CategoriesContext.Provider value={{
    categories,
    addCategory,
    updateCategory,
    removeCategory,
    reorderCategories
  }} data-id="element-951">
      {children}
    </CategoriesContext.Provider>;
}
export function useCategories() {
  const ctx = useContext(CategoriesContext);
  if (!ctx) throw new Error('useCategories must be used within CategoriesProvider');
  return ctx;
}